import AAFPlayer from '../AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY} from '../AAFPlayer/constants';
import { IPTV }  from './../devices/all/settings';
import store from '../store';

  class RequestManagerUtils {  

    showModalError = () => {
      console.log('[TypeConrentStatus] isPlayingLive function');
      const state =  store.getState();
      const cstate = AAFPlayer.getCurrentPlayerOptions(false);
      if (!cstate) return false;
      const { playerstate, islive } = cstate;
      return playerstate === AAFPLAYER_PLAY && islive ? false : true; 
    }; 
  }
  
  export default RequestManagerUtils;


// WEBPACK FOOTER //
// ./src/utils/RequestManagerUtils.js